import React from 'react';
import { WaitlistForm } from './WaitlistForm';
import { Reveal } from './Reveal';
export function FinalCta() {
  return <section className="bg-[linear-gradient(200deg,#311a0a_0%,#241308_55%,#180D05_100%)] pb-14 pt-[94px] text-center" data-id="element-33">
      <div className="mx-auto max-w-[1100px] px-6" data-id="element-34">
        <Reveal data-id="element-35">
          <h2 className="mx-auto max-w-[620px] text-[clamp(26px,4.2vw,42px)] leading-[1.16] text-white" data-id="element-36">
            CUANDO ABRAMOS, LOS DE LA LISTA ENTRAN PRIMERO.{' '}
            <span className="text-camel" data-id="element-37">SUMATE ANTES QUE SE AGOTE.</span>
          </h2>
        </Reveal>
        <Reveal className="mt-7" data-id="element-38">
          <WaitlistForm variant="final" submitLabel="ANOTAME" data-id="element-39" />
        </Reveal>
      </div>
    </section>;
}